import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

function App() {
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    const fetchEmpresas = async () => {
      const { data, error } = await supabase
        .from("vista_directorio")
        .select("razon_comercial, logo, pagina_web")
        .or("comite1.eq.11,scomite1.eq.12")
        .order("razon_comercial", { ascending: true });  // ← ordena alfabéticamente

      if (error) {
        console.error("Error al obtener datos:", error);
      } else {
        setEmpresas(data);
      }
    };

    fetchEmpresas();
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6 p-4">
      {empresas.map((empresa, i) => ( 
        <div
          key={i}
          className="bg-white rounded-2xl shadow-md p-4 flex flex-col items-center"
        >
          <img
            src={empresa.logo || "/img/nologo.jpg"}
            alt={empresa.razon_comercial}
            className="h-24 object-contain mb-4"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/img/nologo.jpg";
            }}
          />

          <h3 className="text-center text-lg font-bold text-gray-800 m-4">
            {empresa.razon_comercial}
          </h3>
          {empresa.pagina_web && (
            <a
              href={empresa.pagina_web}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-semibold hover:underline"
            >
              → Ver más
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

export default App;
